var _g, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBag(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7521 21.5043L41.9606 32.335C42.7265 32.7726 43.2735 33.5385 43.2735 34.5231V60.5607C43.2735 62.3111 45.0239 63.4051 46.5555 62.7487L58.2615 57.7162C59.1367 57.388 59.6837 56.5128 59.6837 55.5282V25.9897C59.6837 25.1145 59.1367 24.2393 58.3709 23.9111L33.3179 11.0017C32.6615 10.6735 31.7863 10.6735 31.1299 11.0017L19.7521 17.2376C18.0017 18.2222 18.1111 20.6291 19.7521 21.5043Z",
    fill: "#00C1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9418 13.0803L12.3127 21.3949L39.9914 35.5077L56.511 27.0838L28.9418 13.0803Z",
    stroke: "#131416",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9914 35.5077L56.511 27.0838V54.7624C56.511 56.0752 56.1828 57.2786 55.5264 58.4821C54.87 59.5761 53.8854 60.4513 52.682 61.1077L48.7435 63.0769L43.164 65.9214C42.1794 66.359 41.1948 66.6872 40.1008 66.6872C39.0068 66.6872 37.9127 66.4684 37.0375 65.9214L16.1418 55.4188C14.9384 54.8718 14.0632 53.8872 13.2974 52.7932C12.6409 51.6991 12.3127 50.3863 12.3127 49.0735V21.3949L39.9914 35.5077ZM39.9914 35.5077L56.511 27.0838V23.3641C56.511 23.0359 56.511 20.9573 56.511 20.6291C56.4016 17.2376 54.5418 15.9248 51.4786 14.3932L34.4119 5.75043C31.8956 4.43761 28.8324 6.29744 28.8324 9.14188V9.25128V12.9709L12.3127 21.3949V16.253V16.1436C12.3127 13.2991 15.376 11.4393 17.8922 12.7521L34.8495 21.3949C37.9127 22.9265 39.882 24.2393 39.882 27.6308C39.882 27.959 39.882 30.0376 39.882 30.3658V34.0855V65.265",
    stroke: "#131416",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3932 39.118C21.6953 39.118 21.9402 38.8731 21.9402 38.5709C21.9402 38.2688 21.6953 38.0239 21.3932 38.0239C21.0911 38.0239 20.8462 38.2688 20.8462 38.5709C20.8462 38.8731 21.0911 39.118 21.3932 39.118Z",
    fill: "#131416",
    stroke: "#131416",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2702 41.5248C29.5723 41.5248 29.8172 41.2799 29.8172 40.9778C29.8172 40.6757 29.5723 40.4308 29.2702 40.4308C28.968 40.4308 28.7231 40.6757 28.7231 40.9778C28.7231 41.2799 28.968 41.5248 29.2702 41.5248Z",
    fill: "#131416",
    stroke: "#131416",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9111 56.5128C30.9111 51.4803 27.0821 47.8701 23.5812 47.2137C20.0804 46.5573 17.7829 47.3231 16.9077 49.4017",
    stroke: "#131416",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67 18.0631L61.7292 17.5175",
    stroke: "#FFC100",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1553 9.25194L60.8358 11.9234",
    stroke: "#FFC100",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.429 4L56.4464 8.1225",
    stroke: "#FFC100",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.7932,
    height: 64,
    fill: "white",
    transform: "translate(11 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.fef04197.svg";
export { ForwardRef as ReactComponent };